module.exports = __webpack_public_path__ + "img/cp-ai-1.9f2739fa.jpg";